import { render, staticRenderFns } from "./insurance.vue?vue&type=template&id=6622edfb&scoped=true"
import script from "./insurance.vue?vue&type=script&lang=js"
export * from "./insurance.vue?vue&type=script&lang=js"
import style0 from "./insurance.vue?vue&type=style&index=0&id=6622edfb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622edfb",
  null
  
)

export default component.exports